import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css';
import { SnackbarProvider } from "notistack";
import { Provider } from 'react-redux';
import store from "./redux/store";
// SEC-027/#72: registers the expiry-detection and refresh interceptors once,
// for their side effect, before the app's first API call can go out.
import "./shared/_helpers/sessionRefresh";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <SnackbarProvider maxSnack={1}>
      <App />
    </SnackbarProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
